/* ============================================================
   Grusshoppen mængdeberegner. Formel porteret verbatim fra
   Claude Design. Estimat er VEJLEDENDE — men prisen rammer den
   PRÆCISE N-tons Bigbag-variant (rabattrappen er ikke-lineær, så
   N × 1-tons-varianten ville overprise). Add-to-cart lægger den
   resolvede variant i kurv (qty 1) via /cart/add.js og refresher
   Dawns cart-drawer. Viser fragt-estimat for bigbag PÅ PALLE ud fra gemt
   postnr (localStorage 'gh:postnr') via den delte motor window.GHFreight.
   Idempotent + theme-editor-sikker.
   ============================================================ */
(function () {
  var PC_KEY = 'gh:postnr';
  function storedPc() {
    try { return window.localStorage.getItem(PC_KEY) || ''; } catch (e) { return ''; }
  }
  // "4 tons | 2.7m3" → 4 · "2.4 m3" → 4 (enheder à 0,6 m³)
  function parseUnits(m) {
    var s = String(m);
    var t = s.match(/^(\d+)\s*tons?\b/i);
    if (t) return parseInt(t[1], 10);
    var v = s.match(/^(\d+(?:[.,]\d+)?)\s*m3/i);
    if (v) return Math.round(parseFloat(v[1].replace(',', '.')) / 0.6);
    return null;
  }
  function krRound(ore) {
    return Math.round(ore / 100).toLocaleString('da-DK') + ' kr';
  }
  function fmt(n, d) {
    d = d == null ? 1 : d;
    try { return new Intl.NumberFormat('da-DK', { minimumFractionDigits: d, maximumFractionDigits: d }).format(n); }
    catch (e) { return Number(n).toFixed(d); }
  }
  function money(cents) {
    var v = (cents || 0) / 100;
    try { return new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v) + ' kr'; }
    catch (e) { return v.toFixed(2) + ' kr'; }
  }

  function refreshCart(sections) {
    if (!sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var ni = doc.querySelector('.drawer__inner');
      var ci = drawer.querySelector('.drawer__inner');
      if (ni && ci) ci.innerHTML = ni.innerHTML;
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') { drawer.open(); return; }
    }
    window.location.href = '/cart';
  }

  function initCalc(root) {
    if (root.dataset.ghInit === '1') return;
    root.dataset.ghInit = '1';

    var mats = Array.prototype.slice.call(root.querySelectorAll('[data-gh-mat]'));
    var shapeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-gh-shape] button'));
    var rectBox = root.querySelector('.sliders[data-shape="rect"]');
    var circleBox = root.querySelector('.sliders[data-shape="circle"]');
    var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-gh-slider]'));

    var out = {
      area: root.querySelector('[data-gh-area]'),
      volume: root.querySelector('[data-gh-volume]'),
      tons: root.querySelector('[data-gh-tons]'),
      bigbags: root.querySelector('[data-gh-bigbags]'),
      bigbags2: root.querySelector('[data-gh-bigbags-2]'),
      bigbagLabel: root.querySelector('[data-gh-bigbag-label]'),
      est: root.querySelector('[data-gh-est]'),
      estNote: root.querySelector('[data-gh-est-note]'),
      freight: root.querySelector('[data-gh-calc-freight]'),
      name: root.querySelector('[data-gh-name]'),
      visual: root.querySelector('[data-gh-visual]'),
      addBtn: root.querySelector('[data-gh-add]'),
      addLabel: root.querySelector('[data-gh-add-label]'),
      see: root.querySelector('[data-gh-see]')
    };

    var state = { shape: 'rect', mat: null, bigbags: 1, addVariant: null, addQty: 1 };
    // Find Bigbag-variant der matcher n enheder — eller null (over max → kontakt).
    function bigbagFor(n) {
      if (!state.mat || !state.mat.bigbags) return null;
      for (var i = 0; i < state.mat.bigbags.length; i++) {
        if (parseUnits(state.mat.bigbags[i].u) === n) return state.mat.bigbags[i];
      }
      return null;
    }

    /* Beregneren viser prisen for bigbag PÅ PALLE — det billigste og mest
       almindelige valg. Kran og løs levering prissættes i buyboxen, hvor
       kunden har valgt metode. Fragten kommer fra den delte motor, så tallet
       her ikke kan afvige fra det kunden ser ved køb. */
    function renderFreight() {
      if (!out.freight) return;
      var f = window.GHFreight;
      var pc = storedPc();
      if (!f || !/^\d{4}$/.test(pc)) {
        out.freight.hidden = false;
        out.freight.textContent = '+ fragt — indtast postnr. på produktsiden og se prisen leveret';
        return;
      }
      var zone = f.zoneFor(pc);
      if (!zone) {
        out.freight.hidden = false;
        out.freight.textContent = 'Vi leverer desværre ikke til ' + pc + ' endnu';
        return;
      }
      out.freight.hidden = false;
      var ore = f.bigbagOre('palle', state.bigbags, zone);
      if (ore === null) {
        out.freight.textContent = 'Over ' + f.maxBags + ' bigbags — kontakt os for pris';
        return;
      }
      var txt = '+ fragt ' + krRound(ore) + ' til ' + pc + ' · ' + zone.label + ' (på palle)';
      var cheaper = f.cheaperAbove('palle', state.bigbags, zone);
      if (cheaper && cheaper.saveOre > 0) {
        var extra = cheaper.atBags - state.bigbags;
        txt += ' · tag ' + extra + ' mere og spar ' + krRound(cheaper.saveOre);
      }
      out.freight.textContent = txt;
    }

    function vals() {
      var o = {};
      sliders.forEach(function (s) { o[s.dataset.key] = parseFloat(s.querySelector('[data-gh-range]').value); });
      return o;
    }

    function compute() {
      var v = vals();
      var area = state.shape === 'rect' ? (v.len * v.wid) : (Math.PI * Math.pow(v.dia / 2, 2));
      var volume = area * (v.depth / 100);
      if (out.area) out.area.textContent = fmt(area, 1) + ' m²';
      if (out.volume) out.volume.textContent = fmt(volume, 2) + ' m³';
      if (!state.mat) {
        if (out.tons) out.tons.textContent = '—';
        return;
      }
      var density = parseFloat(state.mat.density) || 1.5;
      var tons = volume * density;
      var bigbags = Math.max(1, Math.ceil(tons));
      state.bigbags = bigbags;
      if (out.tons) out.tons.textContent = fmt(tons, 1) + ' ton';
      if (out.bigbags) out.bigbags.textContent = bigbags;
      if (out.bigbags2) out.bigbags2.textContent = bigbags;
      if (out.bigbagLabel) out.bigbagLabel.textContent = bigbags > 1 ? 'bigbags' : 'bigbag';

      // Præcis mængde-variant (rabattrappe) — fallback: N × 1-enheds-pris.
      var exact = bigbagFor(bigbags);
      var estOre;
      if (exact) {
        estOre = exact.price;
        state.addVariant = exact.available ? exact.id : null;
        state.addQty = 1;
        if (out.estNote) out.estNote.textContent = 'bigbag, leveret + fragt';
        if (out.addLabel) out.addLabel.textContent = 'Læg ' + bigbags + ' bigbag' + (bigbags > 1 ? 's' : '') + ' i kurv';
      } else if (bigbags > 1 && state.mat.bigbags && state.mat.bigbags.length) {
        // over største variant → kontakt os
        estOre = null;
        state.addVariant = null;
        if (out.estNote) out.estNote.textContent = 'over ' + parseUnits(state.mat.bigbags[state.mat.bigbags.length - 1].u) + ' — ring til os';
        if (out.addLabel) out.addLabel.textContent = 'Ring til os om ' + bigbags + ' bigbags';
      } else {
        estOre = bigbags * (parseInt(state.mat.price, 10) || 0);
        state.addVariant = state.mat.variant || null;
        state.addQty = bigbags;
        if (out.estNote) out.estNote.textContent = 'fra-pris';
        if (out.addLabel) out.addLabel.textContent = 'Læg ' + bigbags + ' bigbag' + (bigbags > 1 ? 's' : '') + ' i kurv';
      }
      if (out.est) out.est.textContent = estOre === null ? '—' : money(estOre);
      renderFreight();
      if (out.addBtn) out.addBtn.disabled = !state.addVariant;
    }

    function selectMat(btn) {
      mats.forEach(function (m) { m.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var bigbags = [];
      try { bigbags = JSON.parse(btn.dataset.bigbags || '[]'); } catch (e) { bigbags = []; }
      state.mat = {
        name: btn.dataset.name, density: btn.dataset.density, price: btn.dataset.price,
        variant: btn.dataset.variant, bigbags: bigbags, url: btn.dataset.url, image: btn.dataset.image
      };
      if (out.name) out.name.textContent = state.mat.name;
      if (out.visual && state.mat.image) { out.visual.src = state.mat.image; out.visual.style.display = 'block'; }
      if (out.see && state.mat.url) out.see.setAttribute('href', state.mat.url);
      compute();
    }
    root._ghSelectHandle = function (handle) {
      var b = mats.filter(function (m) { return m.dataset.handle === handle; })[0];
      if (b) selectMat(b);
    };

    mats.forEach(function (m) { m.addEventListener('click', function () { selectMat(m); }); });

    shapeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.shape = b.dataset.shape;
        shapeBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        if (rectBox) rectBox.hidden = state.shape !== 'rect';
        if (circleBox) circleBox.hidden = state.shape !== 'circle';
        compute();
      });
    });

    sliders.forEach(function (s) {
      var input = s.querySelector('[data-gh-range]');
      var valEl = s.querySelector('[data-gh-slider-val]');
      function paint() {
        var min = parseFloat(input.min), max = parseFloat(input.max), val = parseFloat(input.value);
        var pct = ((val - min) / (max - min)) * 100;
        input.style.background = 'linear-gradient(to right, var(--yellow-deep) ' + pct + '%, var(--line) ' + pct + '%)';
        if (valEl) valEl.textContent = val.toLocaleString('da-DK');
      }
      input.addEventListener('input', function () { paint(); compute(); });
      paint();
    });

    if (out.addBtn) {
      out.addBtn.addEventListener('click', function () {
        if (!state.addVariant) return;
        out.addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: state.addVariant, quantity: state.addQty || 1,
            sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); }).then(function (data) {
          out.addBtn.disabled = false;
          if (data && data.status) { console.warn('[gh-calc]', data.description || data.message); return; }
          refreshCart(data.sections);
          closeModal();
        }).catch(function () { out.addBtn.disabled = false; window.location.href = '/cart'; });
      });
    }

    // initial material
    var start = root.dataset.start;
    var startBtn = start ? mats.filter(function (m) { return m.dataset.handle === start; })[0] : null;
    if (startBtn) selectMat(startBtn);
    else if (mats.length) selectMat(mats[0]);
    else compute();
  }

  function closeModal() {
    var m = document.querySelector('[data-gh-calc-modal]');
    if (m) { m.hidden = true; document.documentElement.style.overflow = ''; }
  }

  function initModal() {
    var modal = document.querySelector('[data-gh-calc-modal]');
    document.querySelectorAll('[data-gh-open-calc]').forEach(function (btn) {
      if (btn.dataset.ghBound === '1') return;
      btn.dataset.ghBound = '1';
      btn.addEventListener('click', function () {
        if (!modal) { window.location.href = '/pages/beregner'; return; }
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var calc = modal.querySelector('[data-gh-calc]');
        var handle = btn.getAttribute('data-product-handle');
        if (calc && calc._ghSelectHandle && handle) calc._ghSelectHandle(handle);
      });
    });
    if (modal && modal.dataset.ghBound !== '1') {
      modal.dataset.ghBound = '1';
      modal.querySelectorAll('[data-gh-calc-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeModal(); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gh-calc]').forEach(initCalc);
    initModal();
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
